export type Url = string;

export const urlValidation = "([^\\.\\s]+\\.)*([^\\.\\s]+)";
